import { render, staticRenderFns } from "./procuroequipes.vue?vue&type=template&id=536aaf2a"
import script from "./procuroequipes.vue?vue&type=script&lang=js"
export * from "./procuroequipes.vue?vue&type=script&lang=js"
import style0 from "./procuroequipes.vue?vue&type=style&index=0&id=536aaf2a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports